import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Header, Icon, Loader, Responsive, Segment, Tab } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import NonCycleProgramBasicInformation from './NonCycleProgramBasicInformation';
import NonCycleProgramStudentList from './NonCycleProgramStudentList';

class NonCycleProgramDetails extends Component {
    constructor(props) {
        super(props);
        const program = props.location && props.location.state && props.location.state.program;
        if (program) {
            localStorage.setItem('nonCycleProgramId', program.id);
        }
        this.state = {
            program,
            loading: false,
        };
    }

    componentDidMount() {
        if (!this.state.program) {
            const id = localStorage.getItem('nonCycleProgramId');
            if (!id) return;
            this.setState({ loading: true });
            axios.get(`/non-cycle-programs/${id}`)
                .then(res => {
                    this.setState({ program: res.data, loading: false });
                })
                .catch(() => {
                    this.setState({ loading: false });
                    toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                });
        }
    }

    handleProgramRefresh = () => {
        const { program } = this.state;
        if (!program) return;
        this.setState({ loading: true });
        axios.get(`/non-cycle-programs/${program.id}`)
            .then(res => {
                this.setState({ program: res.data, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    render() {
        const { program, loading } = this.state;

        if (loading) {
            return (
                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                    <Loader active inline="centered"/>
                </div>
            );
        }

        if (!program) {
            return null;
        }

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        const panes = [
            {
                menuItem: { content: <FormattedMessage id="externalStudent.basicInformation"/> },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <NonCycleProgramBasicInformation
                            program={program}
                            onRefresh={this.handleProgramRefresh}
                            isStudentService={isStudentService}
                        />
                    </Tab.Pane>
                )
            },
            {
                menuItem: { content: <FormattedMessage id="externalStudent.nonCycleProgramStudents"/> },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <NonCycleProgramStudentList program={program}/>
                    </Tab.Pane>
                )
            },
        ];

        return (
            <Fragment>
                <Header as="h1">
                    <Header.Content>
                        <FormattedMessage id="externalStudent.nonCycleStudyProgram"/>
                    </Header.Content>
                </Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                {`${program.programName}`}
                            </Header.Content>
                            <Header.Subheader>
                                {<FormattedMessage id="externalStudent.programName"/>}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Tab
                            menu={{ color: 'blue', secondary: true, pointing: true }}
                            panes={panes}
                        />
                    </Segment>
                    <ToastContainer position="top-right" hideProgressBar={true}/>
                </Segment.Group>
            </Fragment>
        );
    }
}

export default NonCycleProgramDetails;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleProgram/NonCycleProgramDetails.js